import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import extraFilters from '../../../utils/extra-filter-serializer';
import paramsValidator from '../../../utils/params-validator';
export default class ListRoute extends Route {
  queryParams = {
    pageNumber: { refreshModel: true },
    pageSize: { refreshModel: true },
    extraFilters: { refreshModel: true },
    fullName: { refreshModel: true },
    certificability: { refreshModel: true },
    participationCountOrder: { refreshModel: true },
    latestParticipationOrder: { refreshModel: true },
    lastnameSort: { refreshModel: true },
    divisionSort: { refreshModel: true },
  };

  @service currentUser;
  @service store;

  async model(params) {
    paramsValidator.validateCertificabilityParams(params);

    const customFiltersOptions = await this.currentUser.organization.learnerFiltersOptions;
    const participantList = await this.store.query('organization-participant', {
      filter: {
        organizationId: this.currentUser.organization.id,
        fullName: params.fullName,
        certificability: params.certificability,
        extra: extraFilters.decodeExtraFilters(params.extraFilters),
      },
      sort: {
        participationCount: params.participationCountOrder,
        latestParticipationOrder: params.latestParticipationOrder,
        lastnameSort: params.lastnameSort,
        divisionSort: params.divisionSort,
      },
      page: {
        number: params.pageNumber,
        size: params.pageSize,
      },
    });

    return { participantList, customFiltersOptions };
  }

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.pageNumber = 1;
      controller.pageSize = 50;
      controller.fullName = null;
      controller.certificability = [];
      controller.extraFilters = extraFilters.encodeExtraFilters({});
      controller.participationCountOrder = null;
      controller.latestParticipationOrder = null;
      controller.lastnameSort = 'asc';
      controller.divisionSort = null;
    }
  }

  @action
  refreshModel() {
    this.refresh();
  }
}
